import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  recuperarFornecedor: function(usuario) {
    return Vue.http.post('/api/login/recuperarfornecedor', usuario);
  },
  recuperarFornecedorWeb: function (usuario) {
    return Vue.http.post('/api/login/recuperarfornecedorweb', usuario);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha-fornecedor/servico.js